import React from "react";

import { ErrorBoundary } from "features/error-boundary";
import { DashboardLayout } from "features/layouts/dashboard-layout/components";
import { Authentication } from "features/authentication";
import { TransactionsList } from "features/transactions-list/components";
import { CheckoutList } from "features/checkouts-list/components";
import { WagesList } from "features/wage-list/components";
import { Terminals } from "features/terminals/components";
import { Account } from "features/account/components";
import { Dashboard } from "features/dashboard";
import { NewBusiness } from "features/new-business";
import { News } from "features/news";

export const private_router = [
  {
    path: "/",
    element: <DashboardLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "new-business",
        element: <NewBusiness />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "authentication",
        element: <Authentication />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "transactions",
        element: <TransactionsList />,
      },
      {
        path: "checkout",
        element: <CheckoutList />,
      },
      {
        path: "wages",
        element: <WagesList />,
      },
      {
        path: "terminals",
        element: <Terminals />,
      },
      {
        path: "account",
        element: <Account />,
      },
    ],
  },
];
